import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { LazyImage } from "@website/ui/lazy-image";
import { ListItem } from "@website/ui/list-item";
import { Transition } from "@website/ui/transition";
import { getChannel } from "@website/utils/channel/get-channel";
import { replaceSnappTripBasedOnChannel } from "@website/utils/title-replace";
import { useToggle } from "@website/utils/use-toggle/useToggle";
import { useServices } from "@website/widget/header";
import LOGO from "@website/widget/header/assets/logo.png";
import LOGO_SNAPP from "@website/widget/header/assets/logo_snapp.svg";
import { useEffect } from "react";
const alt_logo = replaceSnappTripBasedOnChannel("snapptrip");
export function TravelServicesMobileDrawer() {
  const $ = _c(15);
  const [drawerIsOpen, toggleDrawer] = useToggle(false);
  const {
    services
  } = useServices();
  let t0;
  let t1;
  if ($[0] !== drawerIsOpen) {
    t0 = () => {
      if (drawerIsOpen) {
        document.body.classList.add("prevent-scroll");
        return _temp;
      }
    };
    t1 = [drawerIsOpen];
    $[0] = drawerIsOpen;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MaterialIcon name="menu" />;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== toggleDrawer) {
    t3 = <Button EndIcon={t2} aria-label="open menu" className="lg:!hidden" color="neutral" equalDimension={true} onClick={toggleDrawer} size="small" variant="text" />;
    $[4] = toggleDrawer;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== services || $[7] !== toggleDrawer) {
    t4 = state => <div className={`bg-on-color-high-emphasis fixed right-0 top-0 z-50 h-full w-0 overflow-y-auto overflow-x-hidden transition-all ease-in-out ${state === "entering" || state === "entered" ? "w-full" : "pointer-events-none"}`}><div className="flex h-16 flex-row items-center gap-2 px-4"><Button EndIcon={<MaterialIcon name="arrow_forward" variant="outlined" />} aria-label="close" color="neutral" equalDimension={true} onClick={toggleDrawer} size="small" variant="text" /><div className="flex flex-1 items-center justify-start"><a aria-label={alt_logo} href="/" itemScope={true}><LazyImage alt={`${alt_logo} logo`} height={78} loading="eager" src={getChannel() === "snapp-ir" ? LOGO_SNAPP.src : LOGO.src} title={replaceSnappTripBasedOnChannel("\u0627\u0633\u0646\u067E \u062A\u0631\u06CC\u067E")} width={137} className="h-8 w-auto" /></a></div></div><nav className="divide-outline-thin divide-y">{services.map(item => <a className="flex" href={item.url} key={item.title} {...item.nofollow && {
          rel: "nofollow"
        }} onClick={toggleDrawer}><ListItem EndIcon={<MaterialIcon name="chevron_left" variant="outlined" />} StartIcon={item.icon} data-noindex="true" title={item.title} /></a>)}</nav></div>;
    $[6] = services;
    $[7] = toggleDrawer;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== drawerIsOpen || $[10] !== t4) {
    t5 = <Transition in={drawerIsOpen} timeout={75}>{t4}</Transition>;
    $[9] = drawerIsOpen;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t5) {
    t6 = <>{t3}{t5}</>;
    $[12] = t3;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp() {
  return document.body.classList.remove("prevent-scroll");
}